import { Button } from '@repo/ui'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { HeadContent, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import type { MyRouterContext } from '@/main'
import type { ErrorComponentProps } from '@tanstack/react-router'

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-2xl font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground">
          {(error instanceof Error && error.message) || 'An unexpected error occurred.'}
        </p>
        <Button onClick={reset}>Try again</Button>
      </div>
    </div>
  )
}

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-2xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground">The page you are looking for does not exist.</p>
        <Button asChild>
          <a href="/">Go home</a>
        </Button>
      </div>
    </div>
  )
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  head: () => ({ meta: [{ title: 'Snowvault' }] }),
  errorComponent: RootErrorComponent,
  notFoundComponent: NotFoundComponent,
  component: () => {
    return (
      <>
        <HeadContent />
        <Outlet />
        {import.meta.env.DEV && !import.meta.env['TEST'] && (
          <TanStackDevtools
            config={{
              position: 'bottom-right'
            }}
            plugins={[
              {
                name: 'Tanstack Router',
                render: <TanStackRouterDevtoolsPanel />
              }
            ]}
          />
        )}
      </>
    )
  }
})
